import { format } from 'date-fns'

export const convertDateFormat = (lossDate: string): string => {
  const date = Date.parse(lossDate)
  return format(date, 'dd.MM.yyyy')
}
